import { useState, useEffect } from 'react';
import { ReactComponent as CloseSvg } from '../../assets/svg/closeCircle.svg';
import ReactPlayer from 'react-player';
import request from '../../lib/request';

const ImageList = ({ images }) => {
  return images.length > 1 ? (
    <div className='relative flex items-center justify-start gap-4 overflow-x-auto scrollbar-hidden snap-mandatory snap-x'>
      {images.map((item, index) => (
        <div
          key={index}
          className='relative flex-shrink-0 w-5/6 snap-always snap-center'
        >
          <img
            src={item.url}
            alt='poster'
            className='object-cover object-center w-full h-full rounded-md'
          />
        </div>
      ))}
    </div>
  ) : (
    <div className='relative flex items-center justify-center'>
      <img
        src={images[0].url}
        alt='poster'
        className='object-cover object-center w-5/6 h-full rounded-md'
      />
    </div>
  );
};

const VideoList = ({ videos }) => {
  return (
    <div className='relative flex items-center justify-start gap-4 overflow-x-auto scrollbar-hidden snap-mandatory snap-x'>
      {videos.map((item, index) => (
        <div
          key={index}
          className='relative flex-shrink-0 w-full snap-always snap-center'
        >
          <ReactPlayer
            url={item.url}
            controls
            width='100%'
            height='100%'
            playsinline={true}
            muted={true}
            config={{
              attributes: {
                controlsList: 'nodownload',
              },
            }}
          />
        </div>
      ))}
    </div>
  );
};

const ActionButton = ({ actionName, onClick }) => {
  return (
    <button
      className={`rounded-full w-full py-2 bg-accent text-black flex justify-center font-bold`}
      onClick={onClick}
    >
      {actionName}
    </button>
  );
};

const MediaNotification = ({ user, openPayDialog }) => {
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    getMediaNotification();
  }, []);

  const getMediaNotification = async () => {
    const { result } = await request.get('/notification/media');
    if (result) {
      setNotification(result);
    }
  };

  const closeNotification = async () => {
    try {
      await request.put(`/notification/media/${notification.id}`);
      setNotification(null);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAction = async () => {
    if (notification.action === 'SUBSCRIBE' && !user.activated) {
      openPayDialog();
    }
    if (notification.action === 'LINK') {
      window.open(notification.link, '_blank');
    }
    await closeNotification();
  };

  return (
    notification && (
      <dialog
        open={Boolean(notification)}
        className='fixed top-[50%] translate-y-[-50%] bg-black p-4 rounded-xl max-w-md w-5/6 z-50 max-h-svh border border-accent'
      >
        <div className='flex justify-end'>
          <button onClick={closeNotification}>
            <CloseSvg color='white' />
          </button>
        </div>
        <h1 className='font-bold mb-2 text-white'>{notification.title}</h1>
        {notification.type === 'IMAGE' ? (
          <ImageList images={notification.media} />
        ) : (
          <VideoList videos={notification.media} />
        )}
        <div className='whitespace-pre-line text-white max-h-24 overflow-y-auto mt-2'>
          {notification.content}
        </div>
        <footer className='mt-4'>
          <ActionButton
            actionName={
              notification.action === 'SUBSCRIBE' && user.activated
                ? 'OK'
                : notification.actionName
            }
            onClick={handleAction}
          />
        </footer>
      </dialog>
    )
  );
};

export default MediaNotification;
